import { inject, Injectable } from '@angular/core';

import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, of } from 'rxjs';

import { DisqualifyReasonsAutomationsActions } from '@core/disqualify-reasons-data';
import { JobWorkflowAutomationsActions } from '@core/offers-data';
import { JobTemplateWorkflowAutomationsActions } from '@recruitee/job-templates-data';
import { PipelineTemplateStageAutomationsActions } from '@recruitee/workflow-templates-data';

@Injectable({ providedIn: 'root' })
export class AutomationTemplatesDataService {
  private readonly store = inject(Store);
  private readonly actions = inject(Actions);

  public fetchTemplates(data: {
    pipelineTemplateId?: number;
    disqualifyReasonId?: number;
    jobId?: number;
    jobTemplateId?: number;
  }) {
    const { pipelineTemplateId, disqualifyReasonId, jobId, jobTemplateId } = data;

    if (pipelineTemplateId) {
      this.store.dispatch(
        PipelineTemplateStageAutomationsActions.fetchAutomationTemplates({
          payload: { id: pipelineTemplateId },
        }),
      );
      return this.actions.pipe(
        ofType(PipelineTemplateStageAutomationsActions.fetchAutomationTemplatesSuccess),
        map(data => data.payload),
      );
    }

    if (disqualifyReasonId) {
      this.store.dispatch(
        DisqualifyReasonsAutomationsActions.fetchAutomationTemplates({
          payload: { id: disqualifyReasonId },
        }),
      );
      return this.actions.pipe(
        ofType(DisqualifyReasonsAutomationsActions.fetchAutomationTemplatesSuccess),
        map(data => data.payload),
      );
    }
    if (jobId) {
      this.store.dispatch(
        JobWorkflowAutomationsActions.fetchAutomationTemplates({
          payload: { id: jobId },
        }),
      );
      return this.actions.pipe(
        ofType(JobWorkflowAutomationsActions.fetchAutomationTemplatesSuccess),
        map(data => data.payload),
      );
    }
    if (jobTemplateId) {
      this.store.dispatch(
        JobTemplateWorkflowAutomationsActions.fetchAutomationTemplates({
          payload: { id: jobTemplateId },
        }),
      );
      return this.actions.pipe(
        ofType(JobTemplateWorkflowAutomationsActions.fetchAutomationTemplatesSuccess),
        map(data => data.payload),
      );
    }

    return of([]);
  }
}
